<template>
  <v-container>
    <v-row>
      <v-col
          md="12"><h4>Admin tools</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col><p>Make a duplicate of this event</p></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
            label="New event code"
            :rules="rules"
            v-model="newEventCode"
            hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            label="New event name"
            :rules="rules"
            v-model="newEventName"
            hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-checkbox
            v-model="includeRounds"
            :label="`Include rounds`"
        ></v-checkbox>
      </v-col>

      <v-col md="3">
        <v-btn
            color="primary"
            elevation="2"
            v-on:click="duplicateEvent()"
        >Duplicate event
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>{{ dupeErrorMessage }}</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import {rounds} from "@/utils/rounds"
//import {teams} from "@/utils/teams";
import {db} from "@/db";

export default {

  data: () => ({
    newEventCode: null,
    newEventName: null,
    dupeErrorMessage: "",
    includeRounds: false,
    rules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
    ],
  }),
  methods: {
    duplicateEvent: function () {
      this.dupeErrorMessage = "";
      if (!this.newEventCode || this.newEventCode === this.$store.state.event.id) {
        this.dupeErrorMessage = "Error: Invalid event code"
        return false;
      }
      // check if the event code already exists
      db.collection("events")
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach((snapshot) => {
              if (snapshot.id === this.newEventCode) {
                this.dupeErrorMessage = "Error: New event code already exists!"
                return false;
              }
            })
            this.copyEvent();
          })

    },
    copyEvent: function(){
      const newEvent = this.$store.state.event;
      newEvent.name = this.newEventName;
      return db.collection(`events/`)
          .doc(this.newEventCode)
          .set(newEvent)
          .then(() => {
            console.log('set event!')
            this.addBoatGroups();
            this.addTeams();
            if (this.includeRounds) {
              this.addRounds();
            }
          })
    },
    addBoatGroups: function () {
      this.$store.state.boatGroups.forEach((boat) => {
        return db.collection(`events/${this.newEventCode}/boatGroups`)
            .doc(boat.id)
            .set(boat)
            .then(() => {
              console.log('boatGroup ' + boat.id + ' set!');
            })
      })
    },
    addTeams: function () {
      this.$store.state.teams.forEach((team) => {
        return db.collection(`events/${this.newEventCode}/teams`)
            .doc(team.id)
            .set(team)
            .then(() => {
              console.log('team ' + team.id + ' set!');
            })
      })
    },
    addRounds: function () {
      this.$store.state.rounds.forEach((round) => {
        return db.collection(`events/${this.newEventCode}/rounds`)
            .doc(round.id)
            .set(round)
            .then(() => {
              console.log('round ' + round.id + ' set!');
            })
      })
    },
  },

  computed: {}
}
</script>

<style>


</style>